(() => {
  const overlay = document.getElementById('cm-page-transition');
  if (!overlay) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const key = 'cm-page-transition-v1';
  let busy = false, destination = null, navigateTimer, releaseTimer;
  const show = () => { try { overlay.showPopover?.(); } catch (_) {} };
  const clear = () => {
    clearTimeout(navigateTimer); clearTimeout(releaseTimer);
    busy = false; destination = null;
    overlay.classList.remove('is-covering', 'is-revealing');
    document.documentElement.classList.remove('cm-transition-arrival');
    try { overlay.hidePopover?.(); sessionStorage.removeItem(key); } catch (_) {}
  };
  const navigate = () => {
    if (!destination) return;
    const url = destination; destination = null;
    try { sessionStorage.setItem(key, JSON.stringify({to:url.pathname+url.search,at:Date.now()})); } catch (_) {}
    location.assign(url.href);
  };
  function eligible(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || motion.matches) return null;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.closest('[data-no-page-transition], [contenteditable="true"]')) return null;
    let url;
    try { url = new URL(link.href, location.href); } catch (_) { return null; }
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
    if (url.pathname === location.pathname && url.search === location.search) return null;
    if (/(?:^|\/)(?:checkout|checkouts|account|challenge|apps|services)(?:\/|$)/i.test(url.pathname) || /\/cart\/(?:add|change|update|clear)/.test(url.pathname)) return null;
    if (url.searchParams.has('preview_theme_id') || url.searchParams.has('section_id') || url.searchParams.has('sections')) return null;
    return url;
  }
  document.addEventListener('click', event => {
    const url = eligible(event);
    if (!url) return;
    event.preventDefault(); event.stopPropagation();
    if (busy) return;
    busy = true; destination = url;
    overlay.classList.remove('is-revealing');
    overlay.classList.add('is-covering'); show();
    navigateTimer = setTimeout(navigate, 1250);
    releaseTimer = setTimeout(clear, 6000);
  }, true);
  window.addEventListener('pageshow', event => { if (event.persisted) clear(); });
  window.addEventListener('pagehide', () => { clearTimeout(navigateTimer); clearTimeout(releaseTimer); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && busy) clear(); });
  motion.addEventListener('change', () => { if (motion.matches) { navigate(); clear(); } });
  if (document.documentElement.classList.contains('cm-transition-arrival')) {
    show();
    requestAnimationFrame(() => requestAnimationFrame(() => {
      overlay.classList.add('is-revealing');
      document.documentElement.classList.remove('cm-transition-arrival');
      releaseTimer = setTimeout(clear, 650);
    }));
  }
})();
